import React, { useEffect, useState } from "react";
import { getApi } from "../../services/api/globalApi";

function UserFilter({ filterDataHandler }) {
  const [showDropDown, setShowDropDown] = useState(false);
  const [searchType, setSearchType] = useState("name");

  const [province, setProvince] = useState([]);

  const getProvince = async () => {
    const params = { notPagination: 1, limit: 50 };
    try {
      const data = await getApi({ path: "admin/utils/provinces", params });
      setProvince(data?.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const changeSearchType = (value) => {
    setSearchType(value);
    setShowDropDown(false);
    filterDataHandler({ page: 1, name: "", mobile: "" });
    document.getElementById("searchInput").value = "";
  };

  useEffect(() => {
    getProvince();
  }, []);

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="w-full flex flex-col sm:flex-row gap-6">
        <div className="w-full sm:w-4/12">
          <label
            className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`}
          >
            استان
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, province: e.target.value })
            }
            id="province"
            className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""} selected>
              همه ی استان ها
            </option>
            {province?.map((item, index) => {
              return (
                <option key={index} value={item._id}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>

        <div className="w-full sm:w-4/12">
          <label
            className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`}
          >
            وضعیت
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, status: e.target.value })
            }
            id="status"
            className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>تمامی کاربر ها</option>
            <option value="active" selected>
              کاربر های فعال
            </option>
            <option value="inactive">کاربر های غیر فعال</option>
          </select>
        </div>
        <div className="w-full sm:w-4/12">
          <label
            className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`}
          >
            وضعیت آرشیو
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, archive: e.target.value })
            }
            id="status"
            className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={0} selected>
              کاربر های غیر آرشیو
            </option>
            <option value={1}>کاربر های آرشیو</option>
          </select>
        </div>
      </div>

      <div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
        className="w-full"
      >
        <div className="flex relative">
          <label
            for="search-dropdown"
            className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
          >
            .
          </label>
          <div class="relative w-full">
            <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
              <svg
                class="w-4 h-4 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              onChange={(e) =>
                filterDataHandler({ page: 1, searchText: e.target.value })
              }
              type="search"
              className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="جست و جو کاربر بر اساس موبایل و نام ..."
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserFilter;
